import GenerationPage from 'pages/GenerationPage/GenerationPage'

export default GenerationPage
